import { MapFile } from "./mapfile";

export class LanguageFile extends MapFile {
    constructor(filename?: string) {
        super(filename);

        this.valueTranslateFn = (value: string) => value
            .replace(/\\n/g, "\n")
            .replace(/\\t/g, "\t")
            .replace(/&([^ ])/g, "$1");
    }
}